export default __webpack_public_path__ + "static/Handshake-98c171f09d18083d63e3874cec1956f4.svg";